import { HardwareItem } from "@/models/structure";
import {
    BaseTransformer,
    getPriceFromCalculationItem,
    getSumFromCalculationItem,
} from "./base.transformers";
import { unwrapRef } from "@/utils/reactive";
import { Hardware } from "../entities/hardware";
import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";

export const HardwareTransformer: BaseTransformer<HardwareItem, Hardware> = {
    toOld(hardware: Hardware) {
        return {
            code: unwrapRef(hardware.code) || "",
            hardwareTypeCode: unwrapRef(hardware.typeCode) || "",
            hardwareValueCode: unwrapRef(hardware.structureType) || "",
            type: unwrapRef(hardware.type) || "",
            qty: unwrapRef(hardware.qty) || 0,
            defaultQty: unwrapRef(hardware.defaultQty) || 0,
            title: unwrapRef(hardware.title) || "",
            area: hardware.dimensions.area.getValue() || 0,
            price: hardware.price.getSystemPrice(CostDealType).getValue() || 0,
            priceB2C:
                hardware.price.getSystemPrice(B2CDealType).getValue() || 0,
            priceB2B:
                hardware.price.getSystemPrice(B2BDealType).getValue() || 0,
            sum: hardware.sum.getSystemPrice(B2CDealType).getValue() || 0,
            dimensions: {
                width: {
                    ft: hardware.dimensions.width.ft,
                    inch: hardware.dimensions.width.inch,
                    fractionA: hardware.dimensions.width.fractionDivisor,
                    fractionB: hardware.dimensions.width.fractionDividend,
                },
                height: {
                    ft: hardware.dimensions.height.ft,
                    inch: hardware.dimensions.height.inch,
                    fractionA: hardware.dimensions.height.fractionDivisor,
                    fractionB: hardware.dimensions.height.fractionDividend,
                },
                perimeterFt: 0,
                areaFt: hardware.dimensions.area.toSquareFt().format(),
            },
        };
    },
    fromOld(hardwareConfig: HardwareItem, calculations) {
        const price = getPriceFromCalculationItem(
            calculations,
            hardwareConfig.type || "",
            hardwareConfig.code,
        );

        const sum = getSumFromCalculationItem(
            calculations,
            hardwareConfig.type || "",
            hardwareConfig.code,
        );

        return new Hardware({
            title: hardwareConfig.title || "",
            code: hardwareConfig.code,
            typeCode: hardwareConfig.hardwareTypeCode,
            structureType: hardwareConfig.hardwareValueCode,
            qty: hardwareConfig.qty,
            defaultQty: hardwareConfig.defaultQty,
            price,
            sum,
        });
    },
};
